// extracted by mini-css-extract-plugin
export default {"ViewPayments":"ViewPayments_ViewPayments__0Elov","Header":"ViewPayments_Header__PGzX1","Body":"ViewPayments_Body__ch-wX"};